import React from "react";

/* Social Item
============================================================================= */

const SocialItem = ({ Icon }) => {
	// Config

	// Render
	return (
		<div className="bg-gray-600 p-1 rounded-full">
			<div className="bg-black p-1 rounded-full">
				<div className="bg-white rounded-full h-8 w-8 flex items-center justify-center">
					<Icon />
				</div>
			</div>
		</div>
	);
};

/* Export
============================================================================= */

export default SocialItem;
